import type { Dispatch, SetStateAction } from 'react';
import Card from '@components/UI/Card';
import { showToast } from '@components/Layout/Toast';
import { showSpinner, hideSpinner } from '@components/Layout/LoadingSpinner';
import { EntrySortingRulesEditor } from '@components/Settings/EntrySortingRulesEditor';
import type { TradingProfile } from '@einhaus/project314-types';
import type { SaveTradingProfileSettings } from './types';

interface EntrySortingRulesSectionProps {
    formData: TradingProfile;
    setFormData: Dispatch<SetStateAction<TradingProfile>>;
    tradingProfileId: number;
    saveSettings: SaveTradingProfileSettings;
}

const EntrySortingRulesSection = ({ formData, setFormData, tradingProfileId, saveSettings }: EntrySortingRulesSectionProps) => {
    return (
        <Card className="mb-4" title="Entry Sorting Rules">
            <EntrySortingRulesEditor
                rules={formData.entrySortingRules || []}
                onChange={(rules) => {
                    const updatedFormData = {
                        ...formData,
                        entrySortingRules: rules
                    };

                    setFormData(updatedFormData);

                    // Save immediately when rules change
                    showSpinner();

                    saveSettings(
                        {
                            tradingProfileId,
                            settings: updatedFormData
                        },
                        {
                            onSuccess: () => {
                                hideSpinner();
                            },
                            onError: () => {
                                hideSpinner();
                                showToast('Failed to save entry sorting rules', 'error');
                            }
                        }
                    );
                }}
            />
        </Card>
    );
};

export default EntrySortingRulesSection;
